<app-popover-secondary (closeCallback)="cancelCallback()"  [customStyle]="'fix-geocode'">
  <ng-container popover-content>
    <div class="heading">
      <div style="display: flex; align-items: center;" class="header">
        <div *ngIf="isEditMode" (click)="backToGeocodeList()" class="back-button">
          <img class="back-icon" src="assets/images/fix-geoback-arrow-left-24.svg" />
        </div>
        Fix Geocode
      </div>
    </div>
    <div class="geocode-wrapper">
      <div class="left-column" [ngClass]="{'edit-geocode-column': isEditMode}">
        <ng-container *ngIf="!isEditMode">
          <ul class="stops-list">
            <ng-container *ngFor="let stop of booking.stops; let stopIndex = index;">
              <li class="stop" *ngIf="stop.address" [ngClass]="{'stop-error': !stop.geoCord}">
                <img class="stop-icon" [src]="stopIndex == 0 ? 'assets/pickup-marker-small.svg': (stopIndex == booking.stops.length - 1 ?
                  'assets/end-marker-small.svg' : 'assets/stop-marker-small.svg')" />
                <div *ngIf="stopIndex !== (booking.stops.length - 1)" class="vertical-connecter"></div>
                <app-button (clickCallback)="editGeocode(stopIndex)" size="tiny" class="edit-btn" type="icon"
                  prefixIconSrc="assets/images/geocode-editicon.svg"></app-button>
                <div class="detail-wrapper">
                  <div class="stop-label geocode-label">Gecode</div>
                  <div class="geocord" *ngIf="stop.geoCord">{{stop.geoCord.replace(',', ', ')}}</div>
                  <div class="geocord" *ngIf="!stop.geoCord">
                    - - - - - - - - - - - - - - - - -<img class="warning-icon" src="assets/warning-circle.svg">
                  </div>
                </div>
                <div class="detail-wrapper">
                  <div class="stop-label stop-type geocode-label">{{getStopType(stopIndex)}}</div>
                  <div class="address">{{stop.address}}</div>
                </div>
              </li>
            </ng-container>
          </ul>
        </ng-container>
        <ng-container *ngIf="isEditMode">
          <!-- <div class="heading">
            <button (click)="backToGeocodeList()" class="back-button"><img class="back-icon"
                src="assets/caret-down-large.svg" /></button>
            Fix Geocode
          </div> -->
          <app-location-search type="googleAddress" [city]="boundingCity" [formControl]="locationControl"
            [getLocationLabel]="getLocationLabel" (changeCallback)="onStopLocationChange($event)"></app-location-search>
          <div class="edit-details-info">
            <div style="display: flex;align-items: center;" class="geocode-label">
              <img src="../../../../assets/images/Geocode-location-24.svg" alt="">
              Gecode
            </div>
            <div class="editable-stop-geocode geocord" *ngIf="selectedStop.geoCord">{{selectedStop.geoCord.replace(',',
              ', ')}}
            </div>
            <div class="editable-stop-geocode" *ngIf="!selectedStop.geoCord">
              - - - - - - - - - - - - - - - - -<img class="warning-icon" src="assets/warning-circle.svg">
            </div>
          </div>
          <!-- <hr class="seperator" /> -->
          <div class="edit-details-info">
            <div class="stop-type" >
              <img class="stop-icon" [src]="selectedStopIndex == 0 ? 'assets/images/geocode-office-24.svg': (selectedStopIndex == booking.stops.length - 1 ?
                  'assets/end-marker-small.svg' : 'assets/stop-marker-small.svg')" />
              <div style="margin-left:25px ;" class="geocode-label">
                {{getStopType(selectedStopIndex)}}
              </div>
            </div>
            <div class="stop-address geocord">{{selectedStop.address}}</div>
          </div>
          <div class="actions-wrapper">
            <app-button (clickCallback)="saveGeocode()" type="primaryFilled" text="Confirm"></app-button>
          </div>
        </ng-container>
      </div>
      <div class="right-column">
        <div class="map-container" id="trip-route-map"></div>
        <app-map-controls *ngIf="map" [focusControl]="false" (focusCallback)="focusMap()" [map]="map"></app-map-controls>
      </div>
    </div>
  </ng-container>
</app-popover-secondary>
<app-loader *ngIf="isSaving"></app-loader>
<app-dialog *ngIf="notification" titleText="Error" type="alert" [buttonText]="['OK']"
  (approveCallback)="onDialogConfirm()">
  {{notification}}
</app-dialog>